import {
  GamePart,
  postGameByGameIdEditTimes,
} from "@aura-frontend/omnibus-az-client";

/**
 * Moves the game's scheduled end (POST /game/{id}/edit-times), as EditEvent
 * does for a live event. The edit replaces the game's parts, so they're sent
 * back unchanged but for the last one's end. Omnibus passes the new times on
 * to the game service, which sends them over the stream.
 */
export const editGameEndTime = async ({
  gameId,
  times,
  endTimeS,
}: {
  gameId: string;
  /** The omnibus game's parts (`currentGame.times`) */
  times: GamePart[];
  /** The new end, in epoch seconds */
  endTimeS: number;
}) => {
  if (times.length === 0) throw new Error("The game has no times to edit");
  await postGameByGameIdEditTimes({
    path: { game_id: gameId },
    body: {
      times: times.map((part, index) =>
        index === times.length - 1 ? { ...part, endTime: endTimeS } : part,
      ),
    },
    throwOnError: true,
  });
};
